import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import styles from './comment-form-wrapper.scss';

const CommentFormWrapper = ({ children, borderWidth }) => {
  const containerClassName = classNames(styles.container, 'forum-card-background-color', 'forum-card-border-color');

  return (
    <div className={containerClassName} style={{ borderWidth }}>
      {children}
    </div>
  );
};

CommentFormWrapper.propTypes = {
  children: PropTypes.node,
  borderWidth: PropTypes.number.isRequired,
};

export default withCardBorderWidth(CommentFormWrapper);



// WEBPACK FOOTER //
// ./app/components/comment-form-wrapper/comment-form-wrapper.js